import { motion } from "framer-motion";
import { BadgeCheck, Truck, ReceiptText, Wrench, Home, MessageCircle } from "lucide-react";
import { WHY_US } from "@/lib/constants";

const ICONS = { BadgeCheck, Truck, ReceiptText, Wrench, Home, MessageCircle };

export default function WhyChooseUs() {
  return (
    <section id="keunggulan" data-testid="why-us-section" className="py-24 lg:py-40 border-t border-ink/10 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 lg:mb-20 flex flex-wrap items-end justify-between gap-8"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Keunggulan )</p>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-4xl md:text-6xl lg:text-7xl">
              Mengapa memilih
              <br />
              <span className="text-stroke">Sanjaya Service</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-ink/50 leading-relaxed">
            Kami bekerja dengan cara yang sederhana dan jujur — datang, periksa, perbaiki.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
          {WHY_US.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
                data-testid={`why-us-item-${i}`}
                className="group bg-white p-8 lg:p-10 hover:bg-[#eef4f7] transition-colors duration-500"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand/15 text-brand-ink">
                  <Icon size={22} />
                </span>
                <h3 className="mt-6 font-display font-bold text-xl tracking-tight">{item.title}</h3>
                <p className="mt-3 text-sm text-ink/50 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
